export default function DualProgram() {
  const programs = [
    {
      title: 'Groove & Glow: Ultimate Freestyle War',
      description: 'The flagship international competition and media platform of Groove & Glow.\n\nUltimate Freestyle War is a multi-market tournament where elite dancers battle through five virtual realms inspired by the Five Elements. Each performance advances a story arc within the Broken Seal universe, blending live dance, cinematic virtual environments, AI choreography and digital community engagement.\n\nThis is the public performance engine of Groove & Glow — designed for audiences, sponsors, media and cultural impact.',
      functions: [
        'Global competition & touring format',
        'Media & livestream engine',
        'Sponsor activation platform',
        'Cultural IP and fan community growth'
      ],
      color: 'from-orange-500 to-orange-600',
      icon: 'ri-trophy-line'
    },
    {
      title: 'Groove & Glow: Elemental Harmony Workshop',
      description: 'The corporate and enterprise experience layer of the Groove & Glow universe.\n\nElemental Harmony Workshop adapts the Five Elements narrative and immersive technology into a collaborative, non-competitive team experience — designed for creativity, wellbeing and connection.\n\nThis is the private, corporate gateway into Groove & Glow — allowing organisations to experience the same worlds, technology and philosophy in a tailored, inclusive format.',
      functions: [
        'Corporate team building & wellness',
        'Leadership & culture programs',
        'Innovation & creativity workshops',
        'Brand & employer experience platform'
      ],
      color: 'from-green-400 to-emerald-500',
      icon: 'ri-team-line'
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-black to-[#0A0A0F]">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-5xl md:text-6xl font-bold text-white text-center mb-6">
          Two Experiences. One Unified Universe.
        </h2>
        
        <p className="text-xl text-gray-300 text-center max-w-4xl mx-auto mb-20 leading-relaxed">
          Groove &amp; Glow operates through two interconnected experiences — each designed for a different audience, but built on the same story universe, technology platform and creative philosophy.
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {programs.map((program, index) => (
            <div 
              key={index}
              className="group relative bg-gradient-to-b from-[#1A1A2E] to-[#0F0F1A] rounded-3xl p-10 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
            >
              {/* Icon Badge */}
              <div className={`w-20 h-20 rounded-full bg-gradient-to-br ${program.color} flex items-center justify-center mb-8 mx-auto group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${program.icon} text-4xl text-white`}></i>
              </div>

              {/* Title */}
              <h3 className="text-3xl font-bold text-white text-center mb-8">
                {program.title}
              </h3>

              {/* Description */}
              <div className="text-gray-300 text-base leading-relaxed mb-10 space-y-4">
                {program.description.split('\n\n').map((paragraph, i) => (
                  <p key={i}>{paragraph}</p>
                ))}
              </div>

              {/* Functions List */}
              <div className="space-y-4">
                <h4 className="text-lg font-semibold text-white mb-4">Key Functions:</h4>
                <ul className="space-y-3">
                  {program.functions.map((func, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <div className={`w-2 h-2 rounded-full bg-gradient-to-br ${program.color} mt-2 flex-shrink-0`}></div>
                      <span className="text-gray-300 text-base">{func}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <a 
            href="#contact" 
            className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full text-white font-bold text-lg hover:shadow-2xl hover:shadow-cyan-500/50 transition-all hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            Request Workshop Proposal
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
